<template>
    <div class="AddTestQuestions">
        <div class="page-header">
            <el-page-header @back="goBack" content="我的试题 - 编辑试题">
            </el-page-header>
        </div>
        <div class="body">
            <div class="ques-content">
                <div class="no-content" v-show="paper.questionsList && paper.questionsList.length == 0">点击左侧题型，添加题目到此处</div>
                <ExamQuesTemplate :isTestEdit="isTestEdit" ref="examQuesTemplate" :paper="paper" @submit="submit"></ExamQuesTemplate>
            </div>
        </div>
    </div>
</template>

<script>
import ExamQuesTemplate from "@/components/examQuesTemplate/index.vue"
import { mapState } from "vuex"
import Paper from "@/components/examQuesTemplate/js/Paper.js"
export default {
    name: 'EditQuestion',
    components: {
        ExamQuesTemplate
    },
    data() {
        return {
            paper: {},
        }
    },
    computed:{
		...mapState(['examQuestionTypeArr']),
        id() {
            return this.$route.query.id
        },
        bid() {
            return this.$route.query.bid
        },
        isTestEdit() {
            let data
            if(this.$route.query.isTestEdit == 'true') {
                data = true
            } else {
                data = false
            }
            return data
        },
	},
    watch:{
        'paper.questionsList': {
            handler(vnew, vold) {
                let total = 0
                let quesCount = 0
                let pageCount = 0
                if (this.paper.questionsList.length > 0) {
                total = this.paper.questionsList.reduce((total, item) => {
                    if(item.score) {
                    return total + item.score
                    } else {
                    return total
                    }
                }, 0)
                this.paper.questionsList.forEach((info) =>{
                    // console.log(info)
                    if (info.questionsTypeId == 402 || info.questionsTypeId == 404) {
                    pageCount++
                    }
                    if (this.examQuestionTypeArr.indexOf(info.questionsTypeId) != -1) {       
                    quesCount++
                    }
                })
                console.log()
                this.$refs.examQuesTemplate.changeSort()
                this.paper.pageCount = pageCount
                this.paper.quesCount = quesCount
                this.paper.totalScore = total
                } else {
                this.paper.totalScore = 0
                }
            },
            deep: true
        },
    },
    created() {
        console.log(`试题id: ${this.id}`)
        // 初始化paper
        this.initFunction()
        // 加载试题
        this.getQuestion() 
    },
    mounted() {
    },
    methods: {
        
        getQuestion() {
            let that = this;
            let params = {
                that: this,
                url: `${this.$config.service.examBankQuesDetail}?id=${this.id}`,
                method: "GET",
                cb(res) {
                    console.log(res)
                    if (res.code == '0') {
                        let question = JSON.parse(res.resultBody.quesJson)
                        question.isedit = true
                        that.paper.questionsList.push(question)
                        that.paper.quesAtive = question.qid

                        console.log(that.paper)
                    }
                },
            };
            this.$util.request(params);
        },
        submit(state) {
            console.log('提交')
            this.paper.questionsList.forEach(info => {
                if (info.questionsTypeId == 100 && info.scoringType == 2) {
                    info.oidScoreArr = []
                    info.scoreArr.forEach((item, index) => {
                    if (typeof(item) == 'undefined') info.scoreArr[index] = 0
                    info.optionList.forEach((el, elindex) => {
                        if (index == elindex) {
                        // console.log(index)
                        info.oidScoreArr[index] = `${el.oid}@${info.scoreArr[index]}`
                        }
                    })
                    })
                }
            })
            let paperJson = JSON.parse(JSON.stringify(this.paper))
            paperJson.questionsList.forEach((info) => {
                // console.log(info)
                if(info.questionsTypeId == 101 && info.answer.length>0) {
                    info.answer = info.answer.join(';')
                }else if(info.questionsTypeId == 101 && info.answer.length == 0) {
                    info.answer = ''
                }
            })
            let that = this;
            let data = {
                id: this.id,
                quesJson: JSON.stringify(paperJson.questionsList[0]),
                bid: this.bid,
				tageName: ''
            }
            let params = {
                that: this,
                url: `${this.$config.service.examBankUpdateQues}`,
                method: "post",
                data: data,
                cb(res) {
                    if (res.code == '0') {
                        if (state) {
                            that.goBack()
                            that.$message({
                                message: '编辑成功',
                                type: 'success'
                            });
                        }
                    } else {
                        that.$message.error(res.message)
                    }
                },
            };
            this.$util.request(params);
            
        },
        initFunction() {
            //默认创建对象
            this.paper = new Paper()
            this.paper.title = this.title
            this.paper.depict = this.depict
        },
        goBack() {
            this.$router.go(-1)
        },
    },
}
</script>

<style lang="scss" scoped>

.AddTestQuestions{
    height: 100%;
    background-color: #fff !important;
    .page-header{
        padding: 20px;
        background-color: rgb(255, 255, 255);
    }
    .form-box{ 
        width: 600px;
        margin: 40px auto 0 auto;
        .title{
            font-size: 16px;
            margin: 0 0 40px 30px;
        }
    }
    .body{
        padding-top: 20px;
        display: flex;
        .ques-content{
            // width: 100%;
            display: block;
            flex: 1;
            flex-basis: auto;
            overflow: auto;
            box-sizing: border-box;
            padding: 0 20px;
        }
        .no-content{
            width: 100%;
            background: #fff;
            padding: 120px 0;
            text-align: center;    
            margin-bottom: 5px;
            box-sizing: border-box;
            font-size: 16px;
            box-shadow: 0 2px 8px 0 rgba(0, 0, 0, .16);
        }
    }
}
</style>